export const CYCLES_REQUIRING_COMPANION = [1, 6, 8, 9];
export const CYCLES_ALLOWING_ALONE = [3, 4, 5, 10];

export function isPousoAlegreUnit(unit) {
  return unit === "POUSO_ALEGRE";
}
